export default {
  computed: {
    _profile() {
      return this.$page.props.auth.profile
    },
    isCompanyUser() {
      return (
        this.$page.props.auth.user && this.$page.props.auth.user.profile_type === 'company_contacts'
      )
    },
    isApplicantUser() {
      return this.$page.props.auth.user && this.$page.props.auth.user.profile_type === 'applicants'
    },
    isGuestUser() {
      return !this.$page.props.auth.user
    },
  },
}
